import {Theme} from '../../../app/theme'

export const getColor = (theme: Theme, highlight: boolean, inactive: boolean) => {
  if (inactive) {
    return theme.colors.textReduced
  }
  return highlight ? theme.colors.textHighlight : 'inherit'
}
